import AutocompleteWithHighlights from './AutocompleteWithHighlights';

export default AutocompleteWithHighlights;